module.exports = __webpack_public_path__ + "img/lider.5685c389.png";